const createDataAttribtues = (refinement) =>
  Object.keys(refinement)
    .map((key) => `data-${key}="${refinement[key]}"`)
    .join(" ");

const renderListItem = (item) =>
  item.refinements
    .map(
      (refinement) =>
        `<li>
      <button class="list-toolbar__current-item" ${createDataAttribtues(
        refinement
      )}>
        ${refinement.label}
        <span class="list-toolbar__current-item-remove"></span>
      </button>
    </li>`
    )
    .join("");

const renderCurrentRefinements = (renderOptions, isFirstRender) => {
  const { items, refine, widgetParams } = renderOptions;

  if (isFirstRender) {
    const ul = document.createElement("ul");
    ul.className = "list-toolbar__current-list list-unstyled";

    widgetParams.container.appendChild(ul);
  }

  widgetParams.container.querySelector("ul").innerHTML = items
    .map(renderListItem)
    .join("");

  [...widgetParams.container.querySelectorAll("button")].forEach((element) => {
    element.addEventListener("click", (event) => {
      const item = Object.keys(event.currentTarget.dataset).reduce(
        (acc, key) => ({
          ...acc,
          [key]: event.currentTarget.dataset[key],
        }),
        {}
      );

      refine(item);
    });
  });
};

export const currentFacets =
  window.instantsearch.connectors.connectCurrentRefinements(
    renderCurrentRefinements
  );
